import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Wrapper = styled(Box)`
  padding: 0;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;
